import TrialModalView from 'components/Trials/ModalView';
import TrialPageView from 'components/Trials/PageView';
import BusinessInfoContextProvider from 'contexts/BusinessContextProvider';
import CreditCardContextProvider from 'contexts/CreditCardDetailsContextProvider';
import NotificationContextProvider from 'contexts/NotificationContextProvider';
import TrialsContextProvider, {
  useTrialsContext,
} from 'contexts/TrialsContextProvider';
import env from 'env';
import useScript from 'hooks/useScript';
import useMobileViewport from 'hooks/useMobileViewport';

import { TrialsGlobalStyles } from './styles';

const TrialsPage = () => {
  useMobileViewport();
  const isProd = process.env.NODE_ENV === 'production';
  const { isRearrangeStepsFlow, showMultiStep } = useTrialsContext() || {};

  const googleMapsSrc = `https://maps.googleapis.com/maps/api/js?key=${env.GOOGLE_MAPS_API_KEY}&libraries=places`;
  const recaptchaSrc = isProd
    ? `https://www.google.com/recaptcha/api.js?render=${env.RECAPTCHA_SITE_KEY}`
    : null;

  useScript({ async: true, src: googleMapsSrc });
  useScript({ async: true, src: recaptchaSrc });

  return isRearrangeStepsFlow || showMultiStep ? (
    <TrialPageView />
  ) : (
    <TrialModalView />
  );
};

const Trials = () => (
  <TrialsContextProvider>
    <CreditCardContextProvider>
      <BusinessInfoContextProvider>
        <TrialsGlobalStyles />
        <NotificationContextProvider>
          <TrialsPage />
        </NotificationContextProvider>
      </BusinessInfoContextProvider>
    </CreditCardContextProvider>
  </TrialsContextProvider>
);

export default Trials;
